/**
 * @protected
 */
export const CLASS_PRINT_MODE = 'printMode';
export const CLASS_HIDE_CONTROLS = 'hideControls';
